import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import { ROLES } from "src/constants";
import MobileLayout from "src/_modules/Users/Driver/DriverLayout";
import LazyRouteWrapper from "../LazyRouteWrapper";

const TrackShipment = lazy(() => import("src/_modules/Users/Driver/TrackShipment"));
const ZoneShipments = lazy(() => import("src/_modules/Users/Driver/ZoneShipments"));

const driverRoutes = (currentUser) => (
    <>
        <Route path="driver" element={currentUser && currentUser?.merchant.role === ROLES.driver ? <MobileLayout isDriver logoType='light' /> : <Navigate to="/auth/driver" />}>
            <Route path="track/:id" element={<LazyRouteWrapper><TrackShipment /></LazyRouteWrapper>} />
            <Route path="zone" element={<LazyRouteWrapper><ZoneShipments /></LazyRouteWrapper>} />
            <Route path="" element={<Navigate to="zone" />} />
            <Route path="*" element={<Navigate to="/errors/404" />} />
        </Route>
    </>
)

export default driverRoutes;
